import { matchPath } from "react-router-dom";
import { ROLES } from "../config";

const ONBOARDING_SETUP_ROUTES = [
  "/onboarding",
  "/employment-management",
  "/department",
  "/shifts",
  "/public-holidays",
  "/company-settings",
  "/company-settings/leave-structure",
  "/company-settings/salary-structure",
  "/company-settings/salary-structure/statutory-components",
  "/company-settings/salary-structure/add",
  "/company-settings/salary-structure/edit/:id",
];

export function isOnboardingPathAllowed(pathname, role) {
  if (role !== ROLES.COMPANY_ADMIN) return pathname === "/onboarding";
  return ONBOARDING_SETUP_ROUTES.some(
    (path) => matchPath(path, pathname) || matchPath(`${path}/*`, pathname)
  );
}
